import { useEffect, useCallback } from "react";
import { useParameter, useSubscriptionProviderContext } from "../../../shared";

import { useSlideTitle } from "../hooks/useSlideTitle";
import { useSlideSubtitle } from "../hooks/useSlideSubtitle";
import { ApplyParameters } from "../../../shared/components/SubscriptionProvider/SubscriptionProvider.types";

export function useSubscription() {
  const title = useSlideTitle();
  const subtitle = useSlideSubtitle();
  const {
    actions: { setParameters, setTitle, setSubtitle, setApplyParametersFunction },
  } = useSubscriptionProviderContext();

  const [calendar] = useParameter<number[]>("@calendar");
  const [crop_calendar, setCropCalendar] = useParameter<number>("@crop_calendar");

  useEffect(() => {
    setTitle(title);
    setSubtitle(subtitle);
    setParameters({
      "@calendar": calendar,
      "@crop_calendar": crop_calendar,
    });
  }, [title, subtitle, crop_calendar, calendar, , setParameters]);

  const applyParameters = useCallback((parameters: ApplyParameters) => {
    setCropCalendar((parameters["@crop_calendar"].value as string[]).map(Number)[0]);
  }, []);

  useEffect(() => {
    setApplyParametersFunction(applyParameters);
  }, [setApplyParametersFunction, applyParameters]);
}
